import { ManagerFeature } from "../../store/UIStore/UIStore";
import { Permissions } from "@whatsper/texterchat-common";
export const MANAGER_FEATURE_TO_PATH = {
    [ManagerFeature.LABELS]: 'labels',
    [ManagerFeature.AGENTS]: 'agents',
    [ManagerFeature.DEPARTMENTS]: 'departments',
    [ManagerFeature.CHANNELS]: 'channels',
    [ManagerFeature.API_TOKENS]: 'developers/api-tokens',
    [ManagerFeature.OAUTH]: 'developers/oauth',
};
/**
 * Entity ID key used by each manager feature
 *
 */
export const MANAGER_FEATURE_ENTITY_ID_KEY = {
    [ManagerFeature.LABELS]: 'id',
    [ManagerFeature.AGENTS]: '_id',
    [ManagerFeature.DEPARTMENTS]: '_id',
    [ManagerFeature.CHANNELS]: '_id',
    [ManagerFeature.API_TOKENS]: '_id',
    [ManagerFeature.OAUTH]: '_id',
};
export const MANAGER_FEATURE_PERMISSIONS = {
    [ManagerFeature.AGENTS]: {
        viewPermissions: [Permissions.Permission.users_view],
        managePermissions: [Permissions.Permission.users_manage],
    },
    [ManagerFeature.CHANNELS]: {
        viewPermissions: [Permissions.Permission.channels_view],
        managePermissions: [Permissions.Permission.channels_manage],
    },
    [ManagerFeature.DEPARTMENTS]: {
        viewPermissions: [Permissions.Permission.departments_view],
        managePermissions: [Permissions.Permission.departments_manage],
    },
    [ManagerFeature.LABELS]: {
        viewPermissions: [Permissions.Permission.labels_manage],
        managePermissions: [Permissions.Permission.labels_manage],
    },
    [ManagerFeature.API_TOKENS]: {
        viewPermissions: [Permissions.Permission.api_tokens_view],
        managePermissions: [Permissions.Permission.api_tokens_manage],
    },
    [ManagerFeature.OAUTH]: {
        viewPermissions: [Permissions.Permission.oauth_manage_all],
        managePermissions: [Permissions.Permission.oauth_manage_all],
    },
};
/**
 * Get view permissions required for a manager feature
 */
export const getViewPermissions = (feature) => {
    var _a, _b;
    return (_b = (_a = MANAGER_FEATURE_PERMISSIONS[feature]) === null || _a === void 0 ? void 0 : _a.viewPermissions) !== null && _b !== void 0 ? _b : [];
};
/**
 * Get manage permissions required for a manager feature
 */
export const getManagePermissions = (feature) => {
    var _a, _b;
    return (_b = (_a = MANAGER_FEATURE_PERMISSIONS[feature]) === null || _a === void 0 ? void 0 : _a.managePermissions) !== null && _b !== void 0 ? _b : [];
};
/**
 * Check if user can view a manager feature
 * Uses OR logic - user needs at least ONE of the required permissions
 */
export const canViewFeature = (feature, hasPermissions) => {
    const required = getViewPermissions(feature);
    return required.some(permission => hasPermissions([permission]));
};
/**
 * Check if user can manage (create/edit) in a manager feature
 * Uses OR logic - user needs at least ONE of the required permissions
 */
export const canManageFeature = (feature, hasPermissions) => {
    const required = getManagePermissions(feature);
    return required.some(permission => hasPermissions([permission]));
};
/**
 * Get the entity ID key for a manager feature
 * Labels use 'id', all others use '_id'
 */
export const getEntityIdKey = (feature) => {
    var _a;
    return (_a = MANAGER_FEATURE_ENTITY_ID_KEY[feature]) !== null && _a !== void 0 ? _a : '_id';
};
